import { Component } from '@angular/core';

import { Register } from '../../shared';


@Register({
  name: 'permissionsContextManager',
  title: 'igo.contexts',
  icon: 'settings'
})
@Component({
  selector: 'igo-permissions-context-manager-tool',
  template: require('./permissions-context-manager-tool.component.html'),
  styles: [require('./permissions-context-manager-tool.component.styl')]
})
export class PermissionsContextManagerToolComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/permissions-context-manager-tool/permissions-context-manager-tool.component.ts